import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ItemFilterModel } from 'src/app/models/filters/item-filter.model';
import { CurrencyModel } from 'src/app/models/management/currency.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {

  constructor(private _httpClient: HttpClient) { }

  createCurrency(currencyContractModel: CurrencyModel): Observable<CurrencyModel> {
    return this._httpClient.post<CurrencyModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.currency.CreateCurrency}`,
      currencyContractModel);
  }

  deleteCurrency(currencyId: number): Observable<CurrencyModel> {
    return this._httpClient.delete<CurrencyModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.currency.DeleteCurrency}/${currencyId}`);
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.currency.ExportGeneralConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  getAllCurrenciesWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.currency.GetAllCurrenciesWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getCurrencyById(currencyId: number): Observable<CurrencyModel> {
    return this._httpClient.get<CurrencyModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.currency.GetCurrencyById}/${currencyId}`)
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.currency.GetColumnsForGeneralConsultationAsync}`);
  }

  getCurrencyByCode(code: string): Observable<CurrencyModel> {
    const itemFilterResponse = new ItemFilterModel("code", null, null, "");
    itemFilterResponse.wildcard = code;
    return this._httpClient.post<CurrencyModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.currency.GetCurrencyByCode}`,
      itemFilterResponse)
  }

  updateCurrency(familyContractModel: CurrencyModel): Observable<CurrencyModel> {
    return this._httpClient.put<CurrencyModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.currency.UpdateCurrency}`,
      familyContractModel);
  }
}
